import PageHead from "@/components/PageHead";
import SafetyWarning from "@/components/SafetyWarning";
import { useTranslation } from "react-i18next";

import "./index.less";


import {
  DEFAULT_RPC,
} from "@/config";
import BN from 'bn.js';
import { useCurrentAccount, useSignAndExecuteTransaction } from "@mysten/dapp-kit";
import ListModalAntd from "@/components/ListModalAntd";
import { useEffect, useMemo, useState } from "react";
import { Alert, Form, Input, message, Segmented, Select } from "antd";
import PrivateKeyOperate from "./components/PrivateKeyOperate";
import WalletOperate from "./components/WalletOperate";

import { SuiClient, getFullnodeUrl } from "@mysten/sui/client";
import { isValidSuiPrivateKey } from "@/utils/check";
import { formatUnits } from "viem";
import { FEE_ADDRESS } from "@/config/feeAddress";
import { decodeSuiPrivateKey } from '@mysten/sui/cryptography';
import { Ed25519Keypair } from '@mysten/sui/keypairs/ed25519';
import { CetusClmmSDK } from '@cetusprotocol/sui-clmm-sdk';
import { initCetusSDK } from "@cetusprotocol/cetus-sui-clmm-sdk";
import { cdnUrl } from "@/utils/cdn";
import MyModal from "./components/MyModal";
import Loader from "@/components/Loader";
import { quoteNeedToken2ForNewPosition, quoteToken2FromToken1_WithSort } from "@/utils/cetus";
import { isSuiCoinType } from "@/utils/suiMethods";
import { getPoolsByTwoCoinTypes } from "@/suiService";
const client = new SuiClient({
  url: DEFAULT_RPC,
});
const sdk = CetusClmmSDK.createSDK({ env: "mainnet", full_rpc_url: DEFAULT_RPC });
const serviceFee = FEE_ADDRESS.sui.createLiquidity.serviceFee;
const serviceFeeReciver = FEE_ADDRESS.sui.createLiquidity.serviceFeeReciver;
type CreatePoolParams = {
  env: 'mainnet' | 'testnet';
  rpcUrl: string;
  // suiprivkey...（建议用这个格式）；decodeSuiPrivateKey 可解析并拿到 secretKey bytes :contentReference[oaicite:3]{index=3}
  suiPrivateKey?: string;
  // 你输入的 TokenA / TokenB（coinType）
  tokenA: string;
  tokenB: string;
  // 你输入的初始价格：tokenB per tokenA（1 A = ? B）
  initialPrice: string;
  // tick spacing（决定费率档）:contentReference[oaicite:4]{index=4}
  tickSpacing: number;
  // 你输入的 tokenA 数量（人类单位）
  tokenAAmount: string;
  // 可选：滑点
  slippage?: number;
  // 可选：集中区间（不传则 full range）
  range?: { minPrice: string; maxPrice: string };
};
export default function LiquidityCreate() {
  const { t, i18n } = useTranslation();
  const options = useMemo(
    () => [
      {
        label: t("customizedAuthorization.walletOperation"),
        value: "walletOperate",
      },
      {
        label: t("customizedAuthorization.privateKeyOperation"),
        value: "privateKeyOperate",
      },
    ],
    [t]
  );
  const dexOptions = useMemo(
    () => [
      {
        label: <><img style={{ width: "16px" }} src={cdnUrl("/img/sui/cetus.png")} alt="" />cetus</>,
        value: "cetus",
      },
    ],
    [t]
  );
  const account = useCurrentAccount();
  const [form] = Form.useForm();
  const initPrice = Form.useWatch("initPrice", form);
  const token1Amount = Form.useWatch("token1Amount", form);
  const token2Amount = Form.useWatch("token2Amount", form);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const feeRate = Form.useWatch("feeRate", form);
  const [walletType, setWalletType] = useState("walletOperate");
  const [basicInfo1, setBasicInfo1] = useState<any>({});
  const [basicInfo2, setBasicInfo2] = useState<any>({});
  const [isCreating, setIsCreating] = useState(false)
  const [hash, setHash] = useState("");
  const [dexType, setDexType] = useState("cetus");
  const [privateAddress, setPrivateAddress] = useState("");
  const [privateKey, setPrivateKey] = useState("");
  const [privateKeyBalance, setPrivateKeyBlance] = useState("0")
  const [balance, setBalance] = useState("");
  const { mutateAsync: signAndExecuteTransaction } = useSignAndExecuteTransaction();
  // 创建流动性时请确保钱包有足够的资金，避免添加失败
  const hintMessage = t("createLiquidity.ensureEnoughFunds")
  const [TickFeeRate, setTickFeeRate] = useState({
    "2": {
      tickSpacing: "2",
      feePeople: "0.01%",
      feeRaw: "100",
      isExiting: false
    },
    "4": {
      tickSpacing: "4",
      feePeople: "0.02%",
      feeRaw: "200",
      isExiting: false
    },
    "6": {
      tickSpacing: "6",
      feePeople: "0.03%",
      feeRaw: "300",
      isExiting: false
    },
    "8": {
      tickSpacing: "8",
      feePeople: "0.04%",
      feeRaw: "400",
      isExiting: false
    },
    "10": {
      tickSpacing: "10",
      feePeople: "0.05%",
      feeRaw: "500",
      isExiting: false
    },
    "20": {
      tickSpacing: "20",
      feePeople: "0.1%",
      feeRaw: "1000",
      isExiting: false
    },
    "30": {
      tickSpacing: "30",
      feePeople: "0.15%",
      feeRaw: "1500",
      isExiting: false
    },
    "40": {
      tickSpacing: "40",
      feePeople: "0.2%",
      feeRaw: "2000",
      isExiting: false
    },
    "60": {
      tickSpacing: "60",
      feePeople: "0.25%",
      feeRaw: "2500",
      isExiting: false
    },
    "80": {
      tickSpacing: "80",
      feePeople: "0.3%",
      feeRaw: "3000",
      isExiting: false
    },
    "100": {
      tickSpacing: "100",
      feePeople: "0.4%",
      feeRaw: "4000",
      isExiting: false
    },
    "120": {
      tickSpacing: "120",
      feePeople: "0.6%",
      feeRaw: "6000",
      isExiting: false
    },
    "160": {
      tickSpacing: "160",
      feePeople: "0.8%",
      feeRaw: "8000",
      isExiting: false
    },
    "200": {
      tickSpacing: "200",
      feePeople: "1%",
      feeRaw: "10000",
      isExiting: false
    },
    "220": {
      tickSpacing: "220",
      feePeople: "2%",
      feeRaw: "20000",
      isExiting: false
    },
    "260": {
      tickSpacing: "260",
      feePeople: "4%",
      feeRaw: "40000",
      isExiting: false
    }
  });
  // poolsRes 是你 axios 返回的 res（也可以直接传 list）
  function syncTickFeeRateWithPools(poolsRes: any) {
    const list =
      poolsRes?.data?.data?.list ??
      poolsRes?.data?.list ??
      poolsRes?.list ??
      [];

    setTickFeeRate((prev) => {
      const next: typeof prev = {} as any;

      // 如果没查到任何池子：全部置为 false
      if (!Array.isArray(list) || list.length === 0) {
        for (const [tickSpacing, item] of Object.entries(prev)) {
          next[tickSpacing] = { ...item, isExiting: false };
        }
        return next;
      }

      const feeSet = new Set<number>(list.map((p: any) => Number(p.feeRate)));

      for (const [tickSpacing, item] of Object.entries(prev)) {
        next[tickSpacing] = {
          ...item,
          // 你原本的逻辑：存在就置 true；这里仍保留“或”逻辑
          isExiting: item.isExiting || feeSet.has(Number(item.feeRaw)),
        };
      }

      return next;
    });
  }

  // console.log("tickFeeRate", TickFeeRate)
  const listmodal1Custom = useMemo(() => [
    "0x2::sui::SUI",
    "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC",
    "0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT"
  ], [/* 真正会变化的源 */])
  const filterList = useMemo(() => ["0x2::sui::SUI", "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC", "0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT"], [/* 真正会变化的源 */]);
  // -----------------------
  // 1) 小工具：coinType 排序（按文档：逐字符 ASCII 比较，较大者为 coin_a）:contentReference[oaicite:2]{index=2}
  // -----------------------
  function sortCoinTypes(coinX: string, coinY: string): { coinTypeA: string; coinTypeB: string } {
    // 这里按 JS 字符串逐字符比较，本质就是字典序（等价于逐字符 ASCII）
    return coinX > coinY ? { coinTypeA: coinX, coinTypeB: coinY } : { coinTypeA: coinY, coinTypeB: coinX };
  }
  // -----------------------
  // 2) 小工具：把 "12.34" 转成 base units（BigInt）
  // -----------------------
  function toBaseUnits(amountHuman: string, decimals: number): bigint {
    const s = amountHuman.trim();
    if (!s) throw new Error('amountHuman empty');

    const [intPartRaw, fracPartRaw = ''] = s.split('.');
    const intPart = intPartRaw === '' ? '0' : intPartRaw;
    const fracPart = fracPartRaw.padEnd(decimals, '0').slice(0, decimals);

    const combined = `${intPart}${fracPart}`.replace(/^0+/, '') || '0';
    return BigInt(combined);
  }
  // -----------------------
  // 3) 小工具：价格取倒数（字符串）
  // -----------------------
  function invertPrice(price: string): string {
    // 简单做法：用 JS number（适合常见价格）；你要更高精度可以换 decimal.js
    const p = Number(price);
    if (!Number.isFinite(p) || p <= 0) throw new Error(`invalid price: ${price}`);
    return String(1 / p);
  }

  function invert(x: string): string {
    // 避免 JS 浮点误差：建议用 decimal.js / big.js
    return (1 / Number(x)).toString();
  }

  function normalizePriceAndRange(params: {
    tokenA: string;
    tokenB: string;
    coin_type_a: string;
    coin_type_b: string;
    initialPrice: string; // 你输入的：tokenA per tokenB（1 B = ? A）
    range?: { minPrice: string; maxPrice: string };
  }) {
    const { tokenA, tokenB, coin_type_a, coin_type_b, initialPrice, range } = params;

    // 目标口径：price_base_coin = 'coin_b' => current_price = coin_a per coin_b
    let current_price: string;
    let add_mode_params:
      | { is_full_range: true }
      | { is_full_range: false; min_price: string; max_price: string };

    if (tokenA === coin_type_a && tokenB === coin_type_b) {
      // 你输入的是 A per B，刚好等于 coin_a per coin_b
      current_price = initialPrice;

      add_mode_params = range
        ? { is_full_range: false, min_price: range.minPrice, max_price: range.maxPrice }
        : { is_full_range: true };
    } else if (tokenA === coin_type_b && tokenB === coin_type_a) {
      // 你输入的是 B per A，需要反过来得到 A per B
      current_price = invert(initialPrice);

      if (range) {
        // 区间同样要反转并交换上下界
        const min_price = invert(range.maxPrice);
        const max_price = invert(range.minPrice);
        add_mode_params = { is_full_range: false, min_price, max_price };
      } else {
        add_mode_params = { is_full_range: true };
      }
    } else {
      throw new Error("tokenA/tokenB mismatch after sorting");
    }

    // 强校验，避免合约 abort
    if ("min_price" in add_mode_params) {
      const cp = Number(current_price);
      const mn = Number(add_mode_params.min_price);
      const mx = Number(add_mode_params.max_price);
      if (!(mn < cp && cp < mx)) {
        throw new Error(`Invalid range: require min_price < current_price < max_price, got ${mn} < ${cp} < ${mx}`);
      }
    }

    return { current_price, add_mode_params };
  }

  const getPoolByCoins = async () => {
    const pools = await getPoolsByTwoCoinTypes([basicInfo1.coinType, basicInfo2.coinType])
    syncTickFeeRateWithPools(pools)
    // console.log("pools", pools)

  }
  const copy = async (content: any) => {
    await navigator.clipboard.writeText(content);
    message.success(t("tips.copy"));
  };
  const formatAddress = (str: string) => {
    if (!str) return
    return `${str.slice(0, 15)}...${str.slice(-15)}`;
  }


  async function createCetusClmmPoolWithInitialLiquidity(p: CreatePoolParams) {
    const {
      env,
      rpcUrl,
      suiPrivateKey,
      tokenA,
      tokenB,
      initialPrice,
      tickSpacing,
      tokenAAmount,
      slippage = 0.005,
      range,
    } = p;

    // 私钥建议是 suiprivkey...；decode 后拿 secretKey bytes，再 fromSecretKey :contentReference[oaicite:5]{index=5}
    const parsed = decodeSuiPrivateKey(suiPrivateKey);

    if (parsed.scheme !== 'ED25519') throw new Error(`Only ED25519 demo here, got ${parsed.scheme}`);
    const keypair = Ed25519Keypair.fromSecretKey(parsed.secretKey);

    const sender = keypair.getPublicKey().toSuiAddress();

    // --- Cetus SDK
    const sdk = CetusClmmSDK.createSDK({ env, full_rpc_url: rpcUrl });
    sdk.setSenderAddress(sender); // 文档要求：做资产操作前要设置 sender address :contentReference[oaicite:6]{index=6}

    // --- 先按 Cetus 规则排序 coin_type_a / coin_type_b :contentReference[oaicite:7]{index=7}
    const sorted = sortCoinTypes(tokenA, tokenB);
    const coin_type_a = sorted.coinTypeA;
    const coin_type_b = sorted.coinTypeB;

    // --- decimals（用 Sui Client 读 metadata）
    const metaA = await client.getCoinMetadata({ coinType: coin_type_a });

    const metaB = await client.getCoinMetadata({ coinType: coin_type_b });


    if (!metaA?.decimals || !metaB?.decimals) throw new Error('Failed to fetch coin metadata/decimals');

    const decimalsA = metaA.decimals;
    const decimalsB = metaB.decimals;

    // --- 你输入的 tokenAAmount（基于“你输入的 tokenA”）先转 base units
    const tokenAAmountBase = toBaseUnits(tokenAAmount, tokenA === coin_type_a ? decimalsA : decimalsB);

    // --- fix_amount_a：如果“你输入的 tokenA”刚好就是 coin_type_a，则 fix_amount_a=true；否则 fix_amount_a=false
    const fix_amount_a = tokenA === coin_type_a;

    // --- current_price 的含义：建议统一用 price_base_coin='coin_a'
    //     即：current_price = coin_b per coin_a
    // 你输入的是 tokenB per tokenA：
    //   - 若 tokenA==coin_a 且 tokenB==coin_b：current_price = initialPrice
    //   - 若 tokenA==coin_b 且 tokenB==coin_a：current_price = 1/initialPrice
    const { current_price, add_mode_params } = normalizePriceAndRange({
      tokenA,
      tokenB,
      coin_type_a,
      coin_type_b,
      initialPrice,
      range: range ? { minPrice: range.minPrice, maxPrice: range.maxPrice } : undefined,
    });
    // --- 计算创建池需要的参数（SDK 负责推导 ticks/金额等）:contentReference[oaicite:9]{index=9}
    const calc = await sdk.Pool.calculateCreatePoolWithPrice({
      tick_spacing: tickSpacing,
      current_price,
      coin_amount: tokenAAmountBase.toString(), // 注意：这里是“固定侧”的 base units
      fix_amount_a,
      add_mode_params,
      coin_decimals_a: decimalsA,
      coin_decimals_b: decimalsB,
      price_base_coin: 'coin_b',
      slippage,
    });

    // --- 构建交易（返回 position + 剩余 coin）:contentReference[oaicite:10]{index=10}
    const {
      tx,
      pos_id,
      remain_coin_a,
      remain_coin_b,
      remain_coin_type_a,
      remain_coin_type_b,
    } = await sdk.Pool.createPoolWithPriceReturnPositionPayload({
      tick_spacing: tickSpacing,
      calculate_result: calc,
      add_mode_params,
      coin_type_a,
      coin_type_b,
    });

    // 把剩余 coin 转回自己（如果有）
    // 注：remain_coin_* 的具体类型由 SDK 返回（通常是可转移的 TransactionObjectArgument）
    if (remain_coin_a && remain_coin_type_a) {
      tx.transferObjects([remain_coin_a], sender);
    }
    if (remain_coin_b && remain_coin_type_b) {
      tx.transferObjects([remain_coin_b], sender);
    }

    // 把 LP position NFT 转给自己
    tx.transferObjects([pos_id], sender);
    tx.setSender(sender);

    const [feeCoin] = tx.splitCoins(tx.gas, [serviceFee]);
    tx.transferObjects([feeCoin], serviceFeeReciver);
    // --- 签名执行（Sui TS SDK 标准方式）:contentReference[oaicite:11]{index=11}
    const result = await client.signAndExecuteTransaction({
      signer: keypair,
      transaction: tx,
      options: { showEffects: true, showObjectChanges: true, showEvents: true },
    });
    const digest = result.digest; // ✅ 这就是 tx hash/digest
    const confirmed = await client.waitForTransaction({
      digest,
      options: {
        showEffects: true,
        showEvents: true,
        showObjectChanges: true,
      },
    });

    const status = confirmed.effects?.status?.status; // 'success' | 'failure'
    const error = confirmed.effects?.status?.error;   // 失败原因（可能为空）

    if (status === 'success') {
      console.log('✅ success', digest);
    } else {
      console.log('❌ failure', digest, error);
    }

    return { sender, coin_type_a, coin_type_b, current_price, tickSpacing, result, digest };
  }
  async function createCetusClmmPoolWithInitialLiquidityWithWallet(p: CreatePoolParams) {
    if (!account?.address) throw new Error('Wallet not connected');
    const {
      env,
      rpcUrl,
      tokenA,
      tokenB,
      initialPrice,
      tickSpacing,
      tokenAAmount,
      slippage = 0.005,
      range,
    } = p;
    const sender = account.address;
    // --- Cetus SDK

    sdk.setSenderAddress(sender);
    // --- 排序 coin_type_a / coin_type_b
    const sorted = sortCoinTypes(tokenA, tokenB);
    const coin_type_a = sorted.coinTypeA;
    const coin_type_b = sorted.coinTypeB;
    // --- decimals
    const metaA = await client.getCoinMetadata({ coinType: coin_type_a });
    const metaB = await client.getCoinMetadata({ coinType: coin_type_b });
    if (metaA?.decimals == null || metaB?.decimals == null) {
      throw new Error('Failed to fetch coin metadata/decimals');
    }
    const decimalsA = metaA.decimals;
    const decimalsB = metaB.decimals;
    // --- 固定侧数量（你输入的 tokenAAmount 以“你输入的 tokenA”为基准）
    const tokenAAmountBase = toBaseUnits(
      tokenAAmount,
      tokenA === coin_type_a ? decimalsA : decimalsB
    );

    const fix_amount_a = tokenA === coin_type_a;

    // --- 统一口径：price_base_coin='coin_a' => price = coin_b per coin_a
    const { current_price, add_mode_params } = normalizePriceAndRange({
      tokenA,
      tokenB,
      coin_type_a,
      coin_type_b,
      initialPrice,
      range: range ? { minPrice: range.minPrice, maxPrice: range.maxPrice } : undefined,
    });

    // --- SDK 计算参数
    const calc = await sdk.Pool.calculateCreatePoolWithPrice({
      tick_spacing: tickSpacing,
      current_price,
      coin_amount: tokenAAmountBase.toString(),
      fix_amount_a,
      add_mode_params,
      coin_decimals_a: decimalsA,
      coin_decimals_b: decimalsB,
      price_base_coin: 'coin_b',
      slippage,
    });

    // --- 构建交易（tx 是 Transaction 对象）
    const { tx, pos_id, remain_coin_a, remain_coin_b, remain_coin_type_a, remain_coin_type_b } =
      await sdk.Pool.createPoolWithPriceReturnPositionPayload({
        tick_spacing: tickSpacing,
        calculate_result: calc,
        add_mode_params,
        coin_type_a,
        coin_type_b,
      });

    // --- 处理剩余 coin & position NFT
    if (remain_coin_a && remain_coin_type_a) tx.transferObjects([remain_coin_a], sender);
    if (remain_coin_b && remain_coin_type_b) tx.transferObjects([remain_coin_b], sender);
    tx.transferObjects([pos_id], sender);
    tx.setSender(sender);

    const [feeCoin] = tx.splitCoins(tx.gas, [serviceFee]);
    tx.transferObjects([feeCoin], serviceFeeReciver);
    const txJson = await tx.toJSON();
    // --- ✅ 钱包弹窗签名并发送（mainnet）
    const result = await signAndExecuteTransaction({
      transaction: txJson,
      chain: 'sui:mainnet',
    });
    const digest = result.digest
    const confirmed = await client.waitForTransaction({
      digest,
      options: {
        showEffects: true,
        showEvents: true,
        showObjectChanges: true,
      },
    });

    const status = confirmed.effects?.status?.status; // 'success' | 'failure'
    const error = confirmed.effects?.status?.error;   // 失败原因（可能为空）

    if (status === 'success') {
      console.log('✅ success', digest);
    } else {
      throw Error(error)
    }

    return { sender, coin_type_a, coin_type_b, current_price, tickSpacing, result, digest };
  }

  const getBalance = async (isWallet?: Boolean) => {
    const balanceres = await client.getBalance({
      owner: (isWallet ? account?.address : privateAddress) || "",
    })
    if (isWallet) {
      setBalance(balanceres.totalBalance)
    } else {
      setPrivateKeyBlance(balanceres.totalBalance)
    }

    // console.log("balanceres", balanceres)
  }


  // console.log("basicInfo1", basicInfo1)
  // console.log("basicInfo2", basicInfo2)
  const balanceFun1 = () => {
    if (walletType == "walletOperate" && Object.keys(basicInfo1).length > 0) {
      return formatUnits(basicInfo1.totalBalance, basicInfo1.decimals)
    }
    if (walletType == "privateKeyOperate" && Object.keys(basicInfo1).length > 0) {
      return formatUnits(basicInfo1.totalBalance, basicInfo1.decimals)
    }
    return 0
  }
  const balanceFun2 = () => {
    if (walletType == "walletOperate" && Object.keys(basicInfo2).length > 0) {
      return formatUnits(basicInfo2.totalBalance, basicInfo2.decimals)
    }
    if (walletType == "privateKeyOperate" && Object.keys(basicInfo2).length > 0) {
      return formatUnits(basicInfo2.totalBalance, basicInfo2.decimals)
    }
    return 0
  }


  const addressFun = () => {
    if (walletType == "walletOperate" && account) {
      return account.address
    }
    if (walletType == "privateKeyOperate" && privateAddress) {
      return privateAddress
    }
    return ""
  }
  const setToken1Amount = (raito: any) => {
    if (Object.keys(basicInfo1).length == 0) return
    form.setFieldValue("token1Amount", formatUnits(BigInt(basicInfo1.totalBalance) * BigInt(raito) / BigInt(10), basicInfo1.decimals))
  }
  function toBaseUnitsBN(amountHuman: string, decimals: number): BN {
    const s = amountHuman.trim();
    const [i, f = ""] = s.split(".");
    const frac = f.padEnd(decimals, "0").slice(0, decimals);
    const full = (i + frac).replace(/^0+/, "") || "0";
    return new BN(full);
  }


  async function openNewPositionWithFixedToken1(params: {
    sdk: any;            // CetusClmmSDK 实例（@cetusprotocol/cetus-sui-clmm-sdk）
    pool: any;
    basicInfo1: any;
    basicInfo2: any;
    token1AmountHuman: string;
    rangePct: number;
    slippage: number;
  }) {
    const q = quoteNeedToken2ForNewPosition(params);

    // 固定侧金额：amount_a 或 amount_b
    const fixedBase = toBaseUnitsBN(params.token1AmountHuman, q.token1IsA ? q.tokenA.decimals : q.tokenB.decimals);

    const amount_a = q.token1IsA ? fixedBase.toString() : q.est.tokenMaxA.toString();
    const amount_b = q.token1IsA ? q.est.tokenMaxB.toString() : fixedBase.toString();

    const payload = await params.sdk.Position.createAddLiquidityFixTokenPayload({
      pool_id: params.pool.id,
      pos_id: "0x0",                 // is_open=true 时通常不会用到，给个占位即可
      coinTypeA: params.pool.coin_type_a,
      coinTypeB: params.pool.coin_type_b,

      tick_lower: q.tickLower,
      tick_upper: q.tickUpper,

      amount_a,
      amount_b,

      fix_amount_a: q.token1IsA,
      is_open: true,                 // ✅ 新开 position
      slippage: params.slippage,

      collect_fee: false,
      rewarder_coin_types: [],
    });

    // 你这里：
    // - 私钥模式：client.signAndExecuteTransaction({ signer, transaction: payload, ... })
    // - 钱包模式：signAndExecuteTransaction({ transaction: await payload.toJSON(), chain:'sui:mainnet' })
    return { payload, needToken2AmountHuman: q.needToken2Human, tickLower: q.tickLower, tickUpper: q.tickUpper };
  }

  const start = async () => {
    if (Object.keys(basicInfo1).length == 0 || Object.keys(basicInfo2).length == 0) {
      message.error(t("createLiquidity.pleaseSelectToken"))
      return
    }
    await form.validateFields()
    try {
      setHash("");
      setIsCreating(true)
      if (walletType == "privateKeyOperate") {
        const { digest } = await createCetusClmmPoolWithInitialLiquidity({
          env: 'mainnet',
          rpcUrl: DEFAULT_RPC,
          suiPrivateKey: privateKey,
          tokenA: basicInfo1.coinType,
          tokenB: basicInfo2.coinType,
          initialPrice: initPrice,     // 1 tokenA = 1 tokenB（按你的定义：B/A）
          tickSpacing: feeRate,
          tokenAAmount: token1Amount,
          slippage: 0.1,
          range: { minPrice: String(initPrice * 0.9), maxPrice: String(initPrice * 1.1) }, // 想集中流动性就打开这个
        });
        setHash(digest)

      }
      // walletOperate
      if (walletType == "walletOperate") {
        const { digest } = await createCetusClmmPoolWithInitialLiquidityWithWallet({
          env: 'mainnet',
          rpcUrl: DEFAULT_RPC,
          tokenA: basicInfo1.coinType,
          tokenB: basicInfo2.coinType,
          initialPrice: initPrice,
          tickSpacing: feeRate,
          tokenAAmount: token1Amount,
          slippage: 0.1,
          range: { minPrice: String(initPrice * 0.9), maxPrice: String(initPrice * 1.1) }
        })
        setHash(digest)
      }
      setIsSuccessModalOpen(true)
    } catch (error) {
      setIsErrorModalOpen(true)
      console.log("error", error)
    } finally {
      setIsCreating(false)
    }
  }
  useEffect(() => {
    if (account) {
      getBalance(true)
    } else {
      setBalance("0")
    }
  }, [account])
  useEffect(() => {
    if (privateKey && isValidSuiPrivateKey(privateKey)) {
      getBalance(false)
    } else {
      setPrivateKeyBlance("0")
    }
  }, [privateKey])

  useEffect(() => {
    if (basicInfo1.coinType && basicInfo2.coinType) {
      getPoolByCoins()
    } else {

    }

  }, [basicInfo1.coinType, basicInfo2.coinType])

  useEffect(() => {
    if (initPrice && token1Amount && basicInfo1?.decimals && basicInfo2.decimals) {

      const res = quoteToken2FromToken1_WithSort({ token1Amount, initPriceToken1PerToken2: initPrice, tickSpacing: feeRate, basicInfo1, basicInfo2 })

      form.setFieldValue("token2Amount", res.token2MaxHuman);
    } else {
      form.setFieldValue("token2Amount", (0));
    }

  }, [initPrice, token1Amount, basicInfo1.decimals, basicInfo2.decimals, feeRate]);
  return (
    <div className="page-content liquidity-wrap">
      {/* {contextHolder} */}
      <PageHead
        title={t("createLiquidity.nav")}
        desc={t("createLiquidity.desc")}
      >
        <SafetyWarning />
      </PageHead>

      <Segmented<string>
        className="segmented-wallet"
        style={{ marginTop: "24px" }}
        options={options}
        value={walletType}
        onChange={(value) => {
          setWalletType(value);
          setPrivateKey("");
          setPrivateAddress("");
        }}
      />
      {walletType == "walletOperate" ? (
        <WalletOperate account={account} balance={balance} />
      ) : (
        <PrivateKeyOperate
          privateKey={privateKey}
          setPrivateKey={setPrivateKey}
          setPrivateAddress={setPrivateAddress}
          privateAddress={privateAddress}
          privateKeyBalance={privateKeyBalance}
        />
      )}
      {/* DEX选择 */}
      <div className="dex-option">{t("createLiquidity.dexSelect")}</div>
      <Segmented<string>
        className="segmented-wallet"
        options={dexOptions}
        value={dexType}
        onChange={(value) => {
          setDexType(value);
        }}
      />
      <div className="select-token-section">
        <div className="input-section">
          {/* 基础代币 */}
          <div className="input-title">{t("createLiquidity.baseToken")}</div>
          <ListModalAntd
            address={addressFun()}
            value="0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC"
            custo
            getSelectedTokenInfo={(value: any) => {

              setBasicInfo1({ ...value })
            }}
            customkenCoinTypeLists={listmodal1Custom}
          >
          </ListModalAntd>
        </div>
        <div className="input-section">
          {/* 报价代币 */}
          <div className="input-title">{t("createLiquidity.quoteToken")}</div>
          <ListModalAntd
            address={addressFun()}
            // 请选择代币
            placeholder={t("createLiquidity.pleaseSelectToken")}
            filterAddrs={filterList}
            getSelectedTokenInfo={(value: any) => {
              setBasicInfo2({ ...value })
            }}
          >
          </ListModalAntd>
        </div>
      </div>

      <Form form={form}>
        <div className="setting-section">
          <div className="row">
            <div className="input-section">
              {/* 初始价格 */}
              <div className="input-title">{t("createLiquidity.initialPrice")}</div>
              {/* 请输入初始价格 */}
              <Form.Item name="initPrice" rules={[{ required: true, message: t("createLiquidity.pleaseEnterInitialPrice") }]}>
                <Input placeholder={t("createLiquidity.pleaseEnterInitialPrice")} suffix={Object.keys(basicInfo1).length > 0 && Object.keys(basicInfo2).length > 0 && <>{basicInfo1.symbol + " 每 " + basicInfo2.symbol}</> || <></>}></Input>
              </Form.Item>
              {basicInfo1.symbol && basicInfo2.symbol && initPrice && <>预估价格范围：{Number(Number(initPrice * 0.9).toFixed(9))} - {Number(Number(initPrice * 1.1).toFixed(9))} {basicInfo1.symbol} 每 {basicInfo2.symbol}</>}
            </div>
            <div className="input-section">
              {/* 费率层级 */}
              <div className="input-title">{t("createLiquidity.feeTier")}</div>
              {/* 请费率层级 */}
              <Form.Item name="feeRate" rules={[{ required: true, message: t("createLiquidity.pleaseSelectFeeTier") }]}>
                <Select
                  // defaultValue="lucy"
                  placeholder={t("createLiquidity.pleaseSelectFeeTier")}
                  style={{ width: "100%" }}
                  onChange={() => { }}
                  options={Object.values(TickFeeRate).map((item: any) => ({
                    value: Number(item.tickSpacing),
                    label: <>{item.feePeople} {item.isExiting && <> ({t("rpcServe.exists")})</>}</>,
                    disabled: item.isExiting
                  }))}
                />
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="input-section">
              {/* 加池数量 */}
              <div className="input-title">{t("createLiquidity.addAmount")} {Object.keys(basicInfo1).length > 0 && <span>({basicInfo1.symbol})</span>}</div>
              {/* 请输入加池数量 */}
              <Form.Item name="token1Amount" rules={[{ required: true, message: t("createLiquidity.pleaseEnterAddAmount") }]}>
                <Input placeholder={t("createLiquidity.pleaseEnterAddAmount")} className="cus-ipt"></Input>
              </Form.Item>
              <div className="balance-section">
                <div className="balance">{t("createLiquidity.balance")}：{balanceFun1()}</div>
                <div className="ratio-options">
                  <div className="item" onClick={() => { setToken1Amount(2) }}>20%</div>
                  <div className="item" onClick={() => { setToken1Amount(5) }}>50%</div>
                  <div className="item" onClick={() => { setToken1Amount(8) }}>80%</div>
                  <div className="item" onClick={() => { setToken1Amount(10) }}>100%</div>
                </div>
              </div>
            </div>
            <div className="input-section">
              {/* 加池数量 */}
              <div className="input-title">{t("createLiquidity.addAmount")} {Object.keys(basicInfo2).length > 0 && <span>({basicInfo2.symbol})</span>}</div>
              <Form.Item name="token2Amount" rules={[{ required: true, message: t("createLiquidity.pleaseEnterAddAmount") }]}>
                <Input placeholder="-" className="cus-ipt" disabled></Input>
              </Form.Item>
              <div className="balance-section">
                {/* 余额 */}
                <div className="balance">{t("createLiquidity.balance")}：{balanceFun2()}</div>
                <div className="ratio-options">
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>

      <Alert
        message={
          <div>
            {hintMessage}
          </div>
        }
        type="warning"
        showIcon
        closable
        className="cus-alert"
      />
      {/* 创建流动性 */}
      {!isCreating && <button className="start-btn" onClick={start}>{t("createLiquidity.create")}</button>}
      {isCreating && <button className="start-btn" onClick={start}>
        <Loader>
          <img src={cdnUrl("/img/loading-white.png")} alt="" />
        </Loader>
        {/* 创建流动性中... */}
        {t("createLiquidity.creating")}
      </button>}
      <div className="charge-hint">
        {/* 全网最低服务费，仅需 {formatUnits(FEE_ADDRESS.sui.createLiquidity.serviceFee, 9)} SUI */}
        {t("createLiquidity.lowestServiceFee", { number: formatUnits(FEE_ADDRESS.sui.createLiquidity.serviceFee, 9) })}
      </div>

      {/* 流动性创建成功 */}
      <MyModal isOpen={isSuccessModalOpen} setIsOpen={setIsSuccessModalOpen} title={t("createLiquidity.createSuccess")} img={cdnUrl("/img/check-circle-filled.png")} wrapClassName='create-liquidity-success-modal'>
        {/* 代币地址 */}
        <div className='logo-section'>
          <div>
            <img className='logo-img' src={isSuiCoinType(basicInfo1.coinType) ? cdnUrl("/img/chains/sui.svg") : basicInfo1.iconUrl} alt="" />
            <img className='logo-img' style={{ position: "relative", left: "-8px" }} src={basicInfo2.iconUrl} alt="" />
          </div>
          <div className='minted-amount'>
            {/* 已创建流动性池 */}
            <div>{t("createLiquidity.poolCreated")} {basicInfo1.symbol}/{basicInfo2.symbol}</div>
          </div>
          <div className='name-and-symbol'>1 {basicInfo1.symbol} ≈ {Number(token2Amount / token1Amount).toFixed(4)} {basicInfo2.symbol}</div>
        </div>
        <div className='info-section'>
          <div className='item'>
            {/* 数量 */}
            <div className='left'> {basicInfo1.symbol}{t("createLiquidity.amount")}</div>
            <div className='right'>{token1Amount}</div>
          </div>
          <div className='item'>

            {/* 数量 */}
            <div className='left'> {basicInfo2.symbol}{t("createLiquidity.amount")}</div>
            <div className='right'>{token2Amount}</div>
          </div>
          <div className='item'>
            <div className='left'>HASH</div>
            <div className='right'>
              <div style={{ color: "#0063F7", cursor: "pointer" }} onClick={() => {
                window.open(`https://suivision.xyz/txblock/${hash}`)
              }}>{formatAddress(hash)}</div>
              <img src={cdnUrl("/img/999999copy.svg")} onClick={() => {
                copy(hash)
              }} alt="" />
            </div>
          </div>
        </div>
        <div className='btns'>
          {/* 关闭 */}
          <button className='first-btn' onClick={() => {
            setIsSuccessModalOpen(false)
          }}>{t("tokenCreation.close")}</button>
          {/* 去链上查看 */}
          <button className='second-btn' onClick={() => {
            window.open(`https://suivision.xyz/txblock/${hash}`)
          }}> {t("tokenCreation.viewOnChain")}</button>
        </div>
      </MyModal>
      {/* 失败框 */}
      <MyModal
        // title="流动性创建失败"
        title={t("createLiquidity.createFailed")}
        img={cdnUrl("/img/fail.webp")}
        isOpen={isErrorModalOpen}
        setIsOpen={setIsErrorModalOpen}
      >
        <div className="error-modal-section">
          <div className="row1">
            {/* 温馨提示，中转转账可能失败的原因如下： */}
            {t("IntermediaryTransfer.failReasonTitle")}：
          </div>
          <div className="reason">
            <div>
              {/* 1. BSC链上拥堵，请稍后再试。 */}
              1. {t("IntermediaryTransfer.reason1")}。
            </div>
            <div>2. {t("IntermediaryTransfer.reason2")}</div>
          </div>
          <div className="resolve">
            {/* 您可以将生成的地址文件导入 */}
            {t("IntermediaryTransfer.importFile")}
            {/* 批量查询余额 */}
            <span> {t("IntermediaryTransfer.batchQuery")}</span>
            {/* 功能中，查看资产所在钱包地址。 如果您仍无法找到解决方案，请联系 */}
            {t("IntermediaryTransfer.contactSupport")}
            {/* 官方客服 */}
            <span> {t("IntermediaryTransfer.officialSupport")}</span>
            {/* 以获取帮助。 */}
            {t("IntermediaryTransfer.getHelp")}
          </div>
          <div className="eorrorModal-btns">
            <button
              className="close-btn"
              onClick={() => {
                setIsErrorModalOpen(false);
              }}
            >
              {/* 关闭 */}
              {t("IntermediaryTransfer.close")}
            </button>
            <button
              className="retry-btn"
              onClick={() => {
                setIsErrorModalOpen(false);
              }}
            >
              {/* 再试一次 */}
              {t("IntermediaryTransfer.retry")}
            </button>
          </div>
        </div>
      </MyModal>
      {/* <button onClick={() => { setIsSuccessModalOpen(true) }}>chenggong</button> */}
    </div >
  );
}
